module.exports = __webpack_public_path__ + "img/phone-slash.1ab64cd2.svg";